scriptController.executeWhenScriptLoaded('details-modal.js', () => {
  if (!customElements.get('header-section')) {
    class HeaderSection extends HTMLElement {
      constructor() {
        super();

        const announcementBar = document.querySelector('.announcement-bar'),
          additionalBar = document.querySelector('.additional-bar'),
          header = document.querySelector('.header');

        this.stickyTopSpacing = null;

        const setPageHeadingHeightCSSVariable = function() {
          let announcementBarHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
          let additionalBarHeight = additionalBar ? additionalBar.getBoundingClientRect().height : 0;
          let headerHeight = header ? header.getBoundingClientRect().height : 0;

          document.documentElement.style.setProperty('--announcement-bar-height', `${Math.floor(announcementBarHeight) / 10}rem`);
          document.documentElement.style.setProperty('--additional-bar-height', `${Math.floor(additionalBarHeight) / 10}rem`);
          document.documentElement.style.setProperty('--header-height', `${Math.floor(announcementBarHeight + additionalBarHeight + headerHeight) / 10}rem`);
        };
        
        const setStickyHeightCSSVariable = function() {
          const collectionTopbar = document.querySelector('.template-collection__topbar'),
          productFootbar = document.querySelector('.product-footbar__wrapper--visible'),
          stickyHeader = document.querySelector('sticky-header');
          let height = 0;
          
          if(collectionTopbar) height += collectionTopbar.getBoundingClientRect().height;
          if(productFootbar) height += productFootbar.getBoundingClientRect().height;
          if(stickyHeader?.getStickyHeight) height += stickyHeader.getStickyHeight();

          height = Math.floor(height) / 10;

          if(this.stickyTopSpacing !== height && height !== 0) {
            document.documentElement.style.setProperty('--sticky-top-spacing', `${height}rem`);
          }

          document.documentElement.classList[height && height > 0 ? 'add' : 'remove']('sticky-top-spacing--enable');

          this.stickyTopSpacing = height;
        };

        this.setPageHeadingHeightCSSVariable = setPageHeadingHeightCSSVariable;
        
        window.addEventListener('MutationObserverUnloaded', setPageHeadingHeightCSSVariable, {once: true});
        window.addEventListener('resize', setPageHeadingHeightCSSVariable);
        window.addEventListener('MutationObserverUnloaded', setStickyHeightCSSVariable, {once: true});
        window.addEventListener('MutationObserverLoaded', setStickyHeightCSSVariable);
        window.addEventListener('resize', setStickyHeightCSSVariable);
        window.addEventListener('scroll', setStickyHeightCSSVariable);
        setPageHeadingHeightCSSVariable();

        const cartIconBubble = document.getElementById('cart-icon-bubble');

        if(!cartIconBubble.classList.contains('cart-icon-bubble--cart-drawer')) return;

        const sectionCartDrawer = document.getElementById('cartDrawerSection');
        const detailsModal = sectionCartDrawer.querySelector('details-modal');
        const sectionCartDrawerDetails = 
            sectionCartDrawer.getElementsByTagName('details')[0];
        const cartFooter = document.querySelector('.cart-drawer__footer');
        let lastItemsSize = null;
        let lastWindowHeight = null;
        let lastCartFooterHeight = null;

        const checkFooter = () => {
          if(!sectionCartDrawerDetails.hasAttribute('open')) return;

          const items = sectionCartDrawer.querySelectorAll('.cart-drawer-item');
          let cartFooterHeight = cartFooter.offsetHeight;
          const notesDropdown = cartFooter.querySelector('.animated-dropdown__dropdown');

          if(notesDropdown) cartFooterHeight -= notesDropdown.offsetHeight;
          if(lastItemsSize !== items.length || lastWindowHeight !== themeBase.windowHeight || lastCartFooterHeight !== cartFooterHeight) {
            lastItemsSize = items.length;
            lastWindowHeight = themeBase.windowHeight;
            lastCartFooterHeight = cartFooterHeight;
            
            const itemsWrapper = sectionCartDrawer.querySelector('.cart-drawer__items');
            let itemsBottomLimit = itemsWrapper.offsetTop + lastCartFooterHeight;

            items.forEach((element, index) => {
              if(index >= 2) return false;
              itemsBottomLimit = itemsBottomLimit + (index == 0 ? element.offsetHeight : element.offsetHeight / 2);
            });
            cartFooter.classList[themeBase.windowHeight < itemsBottomLimit - 50 ? 'add' : 'remove']('cart-drawer__footer--static');
          }

          window.requestAnimationFrame(checkFooter);
        };

        function onCartIconBubbleClick(event) {
          event.preventDefault();
          // const sectionCartDrawerSummary = 
          //   sectionCartDrawer.getElementsByTagName('summary')[0];
          const buttonClose = sectionCartDrawer.querySelector('.modal__close-button');
          // sectionCartDrawerSummary.dispatchEvent(new Event('click'));

          detailsModal.open();
          sectionCartDrawer.classList[sectionCartDrawerDetails.hasAttribute('open') ? 'add' : 'remove']('show-cart-drawer');
          checkFooter();
          setTimeout(() => buttonClose.focus(), 100);
        };

        cartIconBubble.addEventListener('click', onCartIconBubbleClick);
        cartIconBubble.addEventListener('triggetClick', onCartIconBubbleClick);
      }

      disconnectedCallback() {
        document.querySelectorAll('mega-menu').forEach(element => element.megaMenuCloseWithoutAnimation());
      }
    }

    customElements.define('header-section', HeaderSection);
    scriptController.scripts.push('header-section.js');
  }
});